var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 78,
    viewBox: "0 0 86 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_491_7532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8492 4.70587C38.4718 -1.56863 47.5283 -1.56862 51.1508 4.70589L80.6976 55.8824C84.3202 62.1569 79.7919 70 72.5468 70H13.4533C6.20808 70 1.67986 62.1569 5.30245 55.8824L34.8492 4.70587Z",
    fill: "url(#paint0_linear_491_7532)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3607 22.3528L46.7197 47.5787H40.4084L39.7674 22.3528H47.3607ZM39.4715 54.6439C39.4222 52.3552 41.2959 50.4894 43.6134 50.5142C45.8075 50.4894 47.7059 52.3552 47.7059 54.6439C47.7059 56.9575 45.8075 58.8234 43.6134 58.8234C41.2959 58.8234 39.4222 56.9575 39.4715 54.6439Z",
    fill: "#7F23F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_491_7532",
    x: 0.0274658,
    y: 0,
    width: 85.9451,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_491_7532"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_491_7532",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_491_7532",
    x1: -9.94111,
    y1: -3.79873,
    x2: 95.9412,
    y2: 90.8575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotFound);
export default __webpack_public_path__ + "static/media/icon_not_found.94293a23bd1b9ce56b23886aed02d401.svg";
export { ForwardRef as ReactComponent };